import { Action } from 'redux';

import ActionFetchCommentSuccess from '../interfaces/actions/ActionFetchCommentSuccess';
import ActionPayloadAny from '../interfaces/actions/ActionPayloadAny';
import ActionPayloadString from '../interfaces/actions/ActionPayloadString';
import Comment from '../interfaces/Comment';

import * as Const from '../constants';

export const fetchCommentsInit = (): Action => {
  return {
    type: Const.FETCH_COMMENTS_INIT,
  };
};

export const fetchCommentsPending = (): Action => {
  return {
    type: Const.FETCH_COMMENTS_PENDING,
  };
};

export const fetchCommentsSuccess = (payload: Comment[]): ActionFetchCommentSuccess => {
  return {
    type: Const.FETCH_COMMENTS_SUCCESS,
    payload,
  };
};

export const fetchCommentsFail = (): Action => {
  return {
    type: Const.FETCH_COMMENTS_FAIL,
  };
};

export const fetchSendCommentsPending = (): Action => {
  return {
    type: Const.FETCH_SEND_COMMENTS_PENDING,
  };
};

export const fetchSendCommentsSuccess = (payload: any): ActionPayloadAny => {
  return {
    type: Const.FETCH_SEND_COMMENTS_SUCCESS,
    payload,
  };
};

export const fetchSendCommentsFail = (): Action => {
  return {
    type: Const.FETCH_SEND_COMMENTS_FAIL,
  };
};

export const fetchCommentsBarHide = (): Action => {
  return {
    type: Const.FETCH_COMMENTS_BAR_HIDE,
  };
};

export const fetchCommentsBarShow = (): Action => {
  return {
    type: Const.FETCH_COMMENTS_BAR_SHOW,
  };
};

export const fetchCommentsValue = (payload: string): ActionPayloadString => {
  return {
    type: Const.FETCH_COMMENTS_VALUE,
    payload,
  };
};
